export default "__VITE_ASSET__APIqdmuo__"